var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M90 180C139.706 180 180 139.706 180 90C180 40.2944 139.706 0 90 0C40.2944 0 0 40.2944 0 90C0 139.706 40.2944 180 90 180Z",
    fill: "#9CC04C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 156.99C126.998 156.99 156.99 126.997 156.99 89.9998C156.99 53.0022 126.998 23.0098 90 23.0098C53.0025 23.0098 23.01 53.0022 23.01 89.9998C23.01 126.997 53.0025 156.99 90 156.99Z",
    fill: "url(#paint0_linear_507_329)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.02 99.71L108.13 73.6C109.21 72.52 110.96 72.52 112.03 73.6L112.07 73.64C113.15 74.72 113.15 76.47 112.07 77.54L83.23 106.38C82.14 107.47 80.37 107.47 79.27 106.38L67.92 95.03C66.84 93.95 66.84 92.2 67.92 91.13L67.96 91.09C69.04 90.01 70.79 90.01 71.86 91.09L80.47 99.7C80.9 100.13 81.58 100.13 82.01 99.7L82.02 99.71Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_507_329",
    x1: 43.81,
    y1: 43.8098,
    x2: 135.41,
    y2: 135.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CC04C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C8036"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.b33e8c77.svg";
export { ForwardRef as ReactComponent };